import * as React from 'react';

import './TrialGroupLayout.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';

import { INavItem, RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { TrialSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface ITrialGroupLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    trial?: Dtos.Trial;
    loadingTrial?: boolean;

    trialGroup?: Dtos.TrialGroup;
    loadingTrialGroup?: boolean;

    loading?: boolean;
    children?: any;
}

interface ITrialGroupLayoutActions {}

type TrialGroupLayoutProps = ITrialGroupLayoutProps & ITrialGroupLayoutActions;

class TrialGroupLayout extends React.PureComponent<TrialGroupLayoutProps, any> {

    constructor(props: TrialGroupLayoutProps) {
        super(props);
    }

    render() {
        const {
            trial,
            loadingTrial,
            trialGroup,
            loadingTrialGroup,
            permissions,
            loading
        } = this.props;

        let groupMenu = this.subMenu();

        return (
            <RestrictedLayout
                subMenuTitle={trial ? trial.shortDisplay : ""}
                trialId={trial ? trial.id : null}
                subMenuItems={loadingTrial == undefined || !trial ? [] : TrialSubMenu(trial.id, permissions)}
                sub2MenuTitle={trialGroup != undefined && trialGroup.group != null ? trialGroup.group.name : ""}
                sub2MenuItems={groupMenu ? groupMenu : []}
                loading={loadingTrial || loadingTrialGroup || loading}
            >
                {this.props.children}
            </RestrictedLayout>
        );
    }

    subMenu() {
        const {
            trialGroup,
            loadingTrialGroup,
            permissions
        } = this.props;

        let menu: INavItem[] = [];

        if (loadingTrialGroup || trialGroup == undefined) return menu;

        if (trialGroup.id !== undefined && trialGroup.id > 0) {
            const isExisting: boolean = trialGroup && trialGroup.id !== undefined && trialGroup.id.toString() !== 'create';
            if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupView, trialGroup.trialId, undefined)) {
                menu.push({
                    icon: undefined,
                    title: "Details",
                    url: "/trials/" + trialGroup.trialId + "/groups/" + trialGroup.id + "/details",
                });
            }
            if (isExisting) {
                if (trialGroup.group !== undefined && AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupView, trialGroup.trialId, undefined)) {    
                    menu.push({
                        icon: undefined,
                        title: "Items",
                        url: "/trials/" + trialGroup.trialId + "/groups/" + trialGroup.id + "/items"
                    });
                }
            }
        } else {
            menu.push({
                icon: undefined,
                title: "Details",
                url: "/trials/" + trialGroup.trialId + "/groups/create/details",
            });
        }

        return menu;
    }
}


const mapStateToProps = (state: ITmdState, ownProps: TrialGroupLayoutProps): ITrialGroupLayoutProps => {

    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let trialGroup: Dtos.TrialGroup | undefined = !(state.trialGroup.formData instanceof Array) ? state.trialGroup.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        permissions: permissions,
        permission: ownProps.permission,

        trial: trial!,
        trialGroup: trialGroup!,

        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
        loadingTrialGroup: state.trialGroup.loadState && state.trialGroup.loadState.status == RequestState.Pending,


        loading: ownProps.loading,
        children: ownProps.children,

    };
};

const mapDispatchToProps = (dispatch): ITrialGroupLayoutActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialGroupLayout);
